import { render, staticRenderFns } from "./RightPannel.vue?vue&type=template&id=2788b74c&scoped=true"
import script from "./RightPannel.vue?vue&type=script&lang=js"
export * from "./RightPannel.vue?vue&type=script&lang=js"
import style0 from "./RightPannel.vue?vue&type=style&index=0&id=2788b74c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2788b74c",
  null
  
)

export default component.exports